import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { GoogleMapsProvider, loadGoogleMaps } from '~/components/AddressAutocomplete';
import { routes } from '~/constants';
import { useIoContext, useStore, useStoreStatic } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { prevBusinessIdKey, useSwitchBusiness } from '~/hooks/useSwitchBusiness';
import { useHomePage } from '~/pages/HomePage/HomePageProvider';
import { clearPersistedOnboardingProgress, deriveVobMode } from './hooks/useOnboardingFlow';
import { VendorOnboarding } from './VendorOnboarding';
export default function VendorOnboardingPage() {
    const history = useHistory();
    const { SP_ONBOARDING_PHASE_1 = false } = useFeatureFlags();
    const { localStorage } = useIoContext();
    const { switchBusiness } = useSwitchBusiness();
    const { setHidden } = useHomePage();
    const { getState } = useStoreStatic();
    const isClient = useStore((state)=>{
        var _state_userInfo;
        return (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.isCustomer();
    });
    const workspaces = useStore((state)=>{
        var _ref;
        var _state_userInfo;
        return (_ref = (_state_userInfo = state.userInfo) === null || _state_userInfo === void 0 ? void 0 : _state_userInfo.workspaces()) !== null && _ref !== void 0 ? _ref : [];
    });
    const handleComplete = useCallback(()=>{
        clearPersistedOnboardingProgress();
        history.replace(routes.vendorDashboard);
    }, [
        history
    ]);
    const handleClose = useCallback(async ()=>{
        var _currentUserInfo_workspaces_find, _currentUserInfo_workspaces;
        clearPersistedOnboardingProgress();
        const currentUserInfo = getState().userInfo;
        const currentBusinessId = currentUserInfo === null || currentUserInfo === void 0 ? void 0 : currentUserInfo.businessId();
        const stashedPrevBusinessId = localStorage.getItem(prevBusinessIdKey);
        const targetBusinessId = stashedPrevBusinessId && stashedPrevBusinessId !== currentBusinessId ? stashedPrevBusinessId : currentUserInfo === null || currentUserInfo === void 0 ? void 0 : (_currentUserInfo_workspaces = currentUserInfo.workspaces()) === null || _currentUserInfo_workspaces === void 0 ? void 0 : (_currentUserInfo_workspaces_find = _currentUserInfo_workspaces.find((ws)=>ws.isCompletelySetup() && ws.id() !== currentBusinessId)) === null || _currentUserInfo_workspaces_find === void 0 ? void 0 : _currentUserInfo_workspaces_find.id();
        if (!targetBusinessId) return;
        setHidden(true);
        try {
            await switchBusiness(targetBusinessId);
        } finally{
            setHidden(false);
        }
    }, [
        getState,
        localStorage,
        setHidden,
        switchBusiness
    ]);
    const handleCloseRef = useRef(handleClose);
    useEffect(()=>{
        handleCloseRef.current = handleClose;
    }, [
        handleClose
    ]);
    useEffect(()=>{
        if (!SP_ONBOARDING_PHASE_1) return undefined;
        window.history.pushState(null, '', window.location.href);
        const handleBrowserBack = ()=>{
            void handleCloseRef.current();
        };
        window.addEventListener('popstate', handleBrowserBack);
        return ()=>window.removeEventListener('popstate', handleBrowserBack);
    }, [
        SP_ONBOARDING_PHASE_1
    ]);
    if (!SP_ONBOARDING_PHASE_1) return /*#__PURE__*/ _jsx(Redirect, {
        to: routes.home
    });
    const vobMode = deriveVobMode({
        sp_onboarding_phase_1: !!SP_ONBOARDING_PHASE_1,
        isClient: !!isClient,
        hasCustomerWorkspace: workspaces.some((w)=>w.isCustomer()),
        hasCompletedVendorWorkspace: workspaces.some((w)=>w.isVendor() && w.isCompletelySetup())
    });
    return /*#__PURE__*/ _jsx(GoogleMapsProvider, {
        loadGoogleMaps: loadGoogleMaps,
        children: /*#__PURE__*/ _jsx(VendorOnboarding, {
            mode: vobMode,
            onComplete: handleComplete,
            onClose: handleClose
        })
    });
}
